import(/* webpackMode: "eager" */ "/Users/gbcimac08/Documents/GitHub/website-v1/src/app/academy/page.tsx")